import React from 'react';
import { ResponsiveEmbed } from 'react-bootstrap';
import JumboContainer from './common/JumboContainer';
import { useTranslation } from 'react-i18next';
import { INTRODUCTION_LABEL } from '../data/i18n/introduction';

const Introduction = () => {

  const {t} = useTranslation();

  return (
    <JumboContainer title={t(INTRODUCTION_LABEL)} id="introduction">
      <ResponsiveEmbed aspectRatio="16by9">
        <iframe
          width="100"
          height="100"
          src="https://www.youtube.com/embed/LgJot4cHHw0"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Introduction Video"
        />
      </ResponsiveEmbed>
    </JumboContainer>
  );
}

export default Introduction;